import { render, staticRenderFns } from "./ContactInputs.vue?vue&type=template&id=18dae6f5"
import script from "./ContactInputs.vue?vue&type=script&lang=js"
export * from "./ContactInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports